import React, { useRef } from 'react';

import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import GaBasicAndUpgradableLimit from 'apps/auth/components/profile/gaLimits/GaBasicAndUpgradableLimit';
import GaLimits from 'apps/auth/components/profile/gaLimits/GaLimits';
import DefaultLimits from 'apps/auth/components/profile/limits/DefaultLimits';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_PROFILE } from 'apps/auth/constants/UrlConstants';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { toLowerCase } from 'apps/auth/helpers/utils';
import { useApp, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';
import { LimitsService } from 'apps/auth/services/LimitsService';

const ProfileGALimitInfoPage = () => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const { basicLimit, profile_form: profileForm, ga_limit, show_modal_terms_ga_update_block, gaLimitsNotAvailable, alarmLimits } = useExtra();
    const {
        gaLimitsNotAvailableText,
        gaLimitsNotAvailablePopupText,
        gotIt,
        profileBusinessLimitsTitle,
        spent,
        profileLimitExpires,
        profileLimitFrodError,
        profileIndividualLimitsTitle,
        gaLimitsGtLimits,
    } = usePageMessages();
    const popupRef = useRef(null);
    const businessLimit = LimitsService.findBusinessLimits(profileForm);
    const hasBusinessLimits = Object.keys(businessLimit).length > 0;

    const onClick = (e) => {
        e.preventDefault();
        popupRef?.current?.open(
            <SimplePopup popupRef={popupRef} text={<div dangerouslySetInnerHTML={{ __html: gaLimitsNotAvailablePopupText }} />}>
                <PopupButton
                    iconName="check"
                    text={gotIt}
                    onClick={() => {
                        popupRef?.current?.close();
                    }}
                />
            </SimplePopup>,
        );
    };

    const businessLimitComponent = (
        <DefaultLimits
            title={profileBusinessLimitsTitle}
            progressWidth={businessLimit.usedPercent}
            isExhaustedLimit={alarmLimits < businessLimit.usedPercent}
            currency={toLowerCase(businessLimit.currencyCode)}
            spendSum={getLocalizedRawAmount(lang, country, businessLimit.used)}
            spendText={spent}
            leftSum={getLocalizedRawAmount(lang, country, businessLimit.max - businessLimit.used)}
            leftText={businessLimit.totalLimitEnd ? profileLimitExpires : null}
            isLimitError={businessLimit.max === 0}
            limitErrorText={profileLimitFrodError}
        />
    );
    return (
        <>
            <CommonPage backUrl={AUTH_PROFILE}>
                {basicLimit && profileForm.upgradable && (
                    <GaBasicAndUpgradableLimit title={hasBusinessLimits ? profileIndividualLimitsTitle : gaLimitsGtLimits} lang={lang} country={country} />
                )}
                {hasBusinessLimits && businessLimitComponent}
                {ga_limit && !show_modal_terms_ga_update_block && <GaLimits lang={lang} country={country} />}
                {gaLimitsNotAvailable && (
                    <Row flex align="center">
                        <Text color="secondary">{gaLimitsNotAvailableText}</Text>
                        <DiskButton
                            iconName="info-rounded"
                            size="small"
                            onClick={onClick}
                            raised={false}
                            variant="tertiary"
                            iconColor="secondary"
                            type="button"
                        />
                    </Row>
                )}
            </CommonPage>
            <PopupNew ref={popupRef} />
        </>
    );
};
export default BasePage(ProfileGALimitInfoPage);
